import { render } from "./AddClientB2B.vue?vue&type=template&id=138b7536&scoped=true"
import script from "./AddClientB2B.vue?vue&type=script&lang=js"
export * from "./AddClientB2B.vue?vue&type=script&lang=js"

import "./AddClientB2B.vue?vue&type=style&index=0&id=138b7536&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-138b7536"]])

export default __exports__